const filterZeroAccounts = accounts => {
 let filteredAccountObj = {};

   for (let accKey in accounts) {
      // skip loop if the property is from prototype
      if (accounts.hasOwnProperty(accKey)){
        let indAccount = accounts[accKey];
        let { payment_amount, minimum_due_amount, recurring_enabled, past_due_amount } = indAccount;
        /*
           Order of checks.
           1. Custom selection saved in payment_amount for each accounts
           2. Handle AutoPay accounts
           3. Handle regular accounts
        */
        if(payment_amount===0){
          continue;
        }
        else if(payment_amount > 0){
          filteredAccountObj[accKey] = payment_amount;
        }
        else if(!((recurring_enabled && past_due_amount === 0) ||(minimum_due_amount <= 0))){
          filteredAccountObj[accKey] = minimum_due_amount;
        }
      }
   }

   return filteredAccountObj
}

export default filterZeroAccounts



// WEBPACK FOOTER //
// ./src/utils/filterZeroAccounts.js